module.exports = __webpack_public_path__ + "static/media/2.0a4a553c.jpg";